import fetch from '../../auth/FetchInterceptor';

export const updateAccount = (accountId, data) => {
  return fetch({
    url: `/accounts/${accountId}`,
    method: 'POST',
    data: data,
  });
};

export const getCurrentAccount = () => {
  return fetch({
    url: `/accounts/current`,
    method: 'GET',
  });
};

export const inviteToAccount = (account_id, data) => {
  return fetch({
    url: `/accounts/${account_id}/invite`,
    method: 'POST',
    data
  });
};

export const getAccountUser = (account_id, user_id) => {
  return fetch({
    url: `/accounts/${account_id}/users/${user_id}`,
    method: 'GET',
  });
};

export const removeAccountUser = (account_id, user_id) => {
  return fetch({
    url: `/accounts/${account_id}/users/${user_id}`,
    method: 'DELETE',
  });
};

export const getIntegrations = function (accountId) {
  return fetch({
    url: `/accounts/${accountId}/integrations`,
    method: 'GET',
  });
};

export const postConnectedAccountSetup = (accountId) => {
  return fetch({
    url: `/accounts/${accountId}/connected_account_setup`,
    method: 'POST',
  });
};

export const disableConnectedAccount = (accountId) => {
  return fetch({
    url: `/accounts/${accountId}/disable_connected_account`,
    method: 'POST',
  });
};
